import store from '@state/store'
import { all, authProtected } from './routes_tools'

// pages
const spreadsheetRoutes = [
  {
    path: '/spreadSheet',
    name: 'Contratos',
    icon: 'file-text',
    header: 'SpreadSheet',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/contract/list')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const requestsRoutes = [
  {
    path: '/requests',
    name: 'Request',
    header: 'Request',
    icon: 'inbox',
    badge: {
      text: '1',
      varient: 'success',
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'fcl',
        name: 'FCL',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/requests/list')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'lcl',
        name: 'LCL',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/requests_lcl/list')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const inlandsRoutes = [
  {
    path: '/inlands',
    name: 'Inlands',
    header: 'Inlands',
    icon: 'map',
    badge: {
      text: '1',
      varient: 'success',
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'requests',
        name: 'Requests',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/inlands/list')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const managementRoutes = [
  {
    path: '/managements',
    name: 'Management',
    header: 'Management',
    icon: 'grid',
    badge: {
      text: '1',
      varient: 'success',
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'carriers',
        name: 'Carriers',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/managements/carrier')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'CompanyUsers',
        name: 'Company Users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/managements/companyUsers')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'harbors',
        name: 'Harbors',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/managements/harbors')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'surchargers',
        name: 'Surchargers',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/managements/surchargers')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'metricsExport',
        name: 'Metrics Export',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/managements/exportMetrics')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const accountsRoutes = [
  {
    path: '/accounts',
    name: 'Accounts',
    header: 'Accounts',
    icon: 'archive',
    badge: {
      text: '1',
      varient: 'success',
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'fcl',
        name: 'FCL',
        meta: { authRequired: true },

        component: () => lazyLoadView(import('@views/pages/accounts/list')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'lcl',
        name: 'LCL',
        meta: { authRequired: true },

        component: () => lazyLoadView(import('@views/pages/accounts_lcl/list')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'localchages',
        name: 'Local Charges',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/accounts_localcharges/list')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const LocalChargesRoutes = [
  {
    path: '/local_charges',
    name: 'Local Charges',
    header: 'Local Charges',
    icon: 'dollar-sign',
    badge: {
      text: '1',
      varient: 'success',
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'adminList',
        name: 'General List',
        meta: { authRequired: true },

        component: () =>
          lazyLoadView(import('@views/pages/localCharges/generalList')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const dynamicsRoutes = [
  {
    path: '/',
    redirect: '/requests/fcl',
    name: 'Dashboard',
  },
  {
    path: '/importation/fcl/:id',
    name: 'goodAndFails',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/importation_fcl/goodAndFails')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/requests/:type/:id',
    name: 'spreadsheet_detail',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/contract/spreadsheet')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/contracts/preprocess/:id',
    name: 'contract_preprocess',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/contract/spreadsheet')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/contracts/preview/:id',
    name: 'contract_preview',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/contract/spreadsheet')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/contracts/data/',
    name: 'contract_data',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/contract/datatable')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reviews/:id/:module',
    name: 'reviews_module',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/reviews/list')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/accounts/:id',
    name: 'account_import',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/accounts/importView')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/accounts_details/:id',
    name: 'account_detail',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/accounts/detail')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/failure_review/:id/:module',
    name: 'goodandfails',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/accounts/goodandfails')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/failure_review_lcl/:id',
    name: 'goodandfails_lcl',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/accounts_lcl/goodandfails')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/failure_review_localcharge/:id',
    name: 'goodandfails_localcharge',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/accounts_localcharges/goodandfails')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/failure_review_inlands/:id',
    name: 'goodandfails_inlands',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/inlands/goodAndFails')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/inlands/importation/:id',
    name: 'importation_inlands',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/inlands/importView')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/multiple_edit_fails_rate/:id/:module',
    name: 'multipleeditfailsrate',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/accounts/multipleeditfailsrate')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/multiple_edit_fails_rate_lcl/:id/:module',
    name: 'multipleeditfailsrateLcl',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/accounts_lcl/multipleeditfailsrate')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reviews_lcl/:id',
    name: 'reviews_module_lcl',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/reviews_lcl/list')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/accounts_lcl/:id',
    name: 'account_import_lcl',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/accounts_lcl/importView')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/accounts_details_lcl/:id',
    name: 'account_detail_lcl',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/accounts_lcl/detail')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/transit_time_importation',
    name: 'transit_time_import',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/transit_times/importView')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/localcharges_importation/:id?',
    name: 'localcharges_import',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/accounts_localcharges/importView')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/localcharge_accounts_details/:id?',
    name: 'account_detail_localcharge',
    meta: { authRequired: true },
    component: () =>
      lazyLoadView(import('@views/pages/accounts_localcharges/detail')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const oceanAnalyticRoutes = [
  {
    path: '/oceanAnalytics',
    name: 'Ocean Analytics',
    header: 'Ocean Analytics',
    icon: 'activity',
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/oceanAnalytics/list')),
  },
]
const MetricasFclRoutes = [
  {
    path: '/requests/fcl/metricas',
    name: 'Requests FCL',
    header: 'Requests Metricas',
    icon: 'activity',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/requests/metricas')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const transitTimesRoutes = [
  {
    path: '/transittimes',
    name: 'Transit Times',
    header: 'Transit Times',
    icon: 'calendar',
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@views/pages/transit_times/list')),
  },
]

const authProtectedRoutes = [
  // ...authProtected,
  // ...spreadsheetRoutes,
  // ...MetricasFclRoutes,
  ...requestsRoutes,
  ...accountsRoutes,
  ...oceanAnalyticRoutes,
  ...transitTimesRoutes,
  ...LocalChargesRoutes,
  ...managementRoutes,
  ...inlandsRoutes,
]
const allRoutes = [...all, ...authProtectedRoutes, ...dynamicsRoutes]

export { allRoutes, authProtectedRoutes }

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@components/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    // error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
